import { useMutation } from 'query';
import { useUpdateMarkAsRead } from '../../hooks';
import { markAsRead } from '../../services';

export const useMarkAsReadMutation = () => {
  const updateCache = useUpdateMarkAsRead();

  return useMutation<
    unknown,
    {
      postId: string;
    }
  >({
    async mutationFn({ postId }) {
      const response = await markAsRead({ id: postId });

      return response.data;
    },
    onSuccess(_data, params) {
      updateCache(params);
    },
  });
};
